import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ITManagedServicesIndustry from "@/pages/industries/ITManagedServicesIndustry";
export const Route = createFileRoute("/industries/it-managed-services")({ head: ({match}) => pageHead(match.pathname), component: () => (<ITManagedServicesIndustry />) });
